import { createFileRoute } from '@tanstack/react-router';
import { TripDetailView } from '@/components/TripDetailView';
import { z } from 'zod';
import { useIsAdmin } from '@/hooks/useIsCompanyAdmin';

const tripDetailSearchSchema = z.object({
  editTripId: z.string().optional(),
  legId: z.string().optional(),
});

export const Route = createFileRoute('/_auth/schedule/$tripId')({
  component: TripDetailRoute,
  validateSearch: tripDetailSearchSchema,
});

function TripDetailRoute() {
  const { tripId } = Route.useParams();
  const { editTripId, legId } = Route.useSearch();
  const { isAdmin, isLoaded} = useIsAdmin();

  return <TripDetailView tripId={tripId} editTripId={editTripId} openLegId={legId} readOnly={true} allowDocumentUpload={true} />;
}
